module.exports = "/_next/static/images/10eb5ad0dbe02073839418f13a2a6211-cuenta-card-xs-full-width.png.webp";